import { inject } from '@angular/core';
import { type CanActivateFn, type CanMatchFn, Router } from '@angular/router';
import { UserStatusSchema } from '@incendi-io/types';
import { map } from 'rxjs/operators';

import { ROUTER_LINKS } from '../interfaces/router-links.enum';
import { Auth0Service } from './oauth0';
import { CurrentUserService } from './services';

function checkAuth(path: string) {
  const auth = inject(Auth0Service);
  const currentUser = inject(CurrentUserService);
  const router = inject(Router);

  if (currentUser.profile) {
    if (!currentUser.profile.firstLogin && !path.includes(ROUTER_LINKS.ONBOARDING)) {
      return router.createUrlTree([ROUTER_LINKS.ONBOARDING]);
    }

    if (currentUser.profile.firstLogin && path.includes(ROUTER_LINKS.ONBOARDING)) {
      return router.createUrlTree([ROUTER_LINKS.HOME]);
    }

    if (currentUser.profile.status === UserStatusSchema.enum.Deactivated && !path.includes(ROUTER_LINKS.DEACTIVATED)) {
      return router.createUrlTree([ROUTER_LINKS.DEACTIVATED]);
    }

    if (currentUser.profile.status !== UserStatusSchema.enum.Deactivated && path.includes(ROUTER_LINKS.DEACTIVATED)) {
      return router.createUrlTree([ROUTER_LINKS.HOME]);
    }

    return true;
  }

  return auth.login().pipe(map(() => false));
}

export const authCanActivate: CanActivateFn = (_route, state) => checkAuth(state.url || '');

export const authCanMatch: CanMatchFn = route => checkAuth(route.path || '');
